import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bcs-divider',
  templateUrl: './bcs-divider.component.html',
  styleUrls: ['./bcs-divider.component.scss'],
})
export class BcsDividerComponent {
  @Input() titleH4 = '';
  @Input() titleH6 = '';
}
